module.exports = __webpack_public_path__ + "static/media/ai-ad-massie-thumbnailDT.c47dc6f8.jpg";